export const environment = {
  production: false,
  clientId: 'patient_app',
  publicKey: 'TrPbi0xJT',
  homePath: '/main/home',
  baseApiUrl: '',
  authServiceUrl: 'https://api.stg-oralgenome.link',
  userServiceUrl: 'https://api.stg-oralgenome.link',
  wellnessServiceUrl: 'https://api.stg-oralgenome.link',
  logLevel: 5,
};
